import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _acceptAccountInviteRequest = {};
var _acceptAccountInviteResponse = {};
var _accountInvite = {
    dateCreated: 'google.protobuf.Timestamp',
    dateUpdated: 'google.protobuf.Timestamp',
    expirationDate: 'google.protobuf.Timestamp',
    assignments: '_inviteResourceAssignment',
};
var _accountInviteRequest = {};
var _accountInviteResponse = { invite: '_accountInvite' };
var _bulkAccountInviteRequest = {};
var _bulkAccountInviteResponse = { invites: '_accountInvite' };
var _conditionType = { joinedConditions: '_joinedCondition' };
var _createInviteRequest = {
    subjectsAssignments: '_subjectInviteAssignments',
};
var _createInviteResponse = { successfulInvites: '_accountInvite' };
var _getAccountInviteRequest = {};
var _getAccountInviteResponse = { invite: '_accountInvite' };
var _getAccountInvitesRequest = {};
var _getAccountInvitesResponse = { invites: '_accountInvite' };
var _inviteAssignment = { condition: '_policyCondition' };
var _inviteResourceAssignment = { assignments: '_inviteAssignment' };
var _joinedCondition = { conditions: '_conditionType' };
var _policyCondition = { condition: '_conditionType' };
var _resendAccountInviteRequest = {};
var _revokeAccountInviteRequest = {};
var _revokeAccountInviteResponse = {};
var _subjectInviteAssignments = { assignments: '_inviteResourceAssignment' };
var _updateAccountInviteAssignmentsRequest = {
    assignments: '_inviteResourceAssignment',
};
var _updateAccountInviteAssignmentsResponse = {};
var _updateAccountInviteRequest = {};
var _updateAccountInviteResponse = {};
function resolveComWixpressInvitesApiAccountInvitesApiUrl(opts) {
    var domainToMappings = {
        'www._base_domain_': [
            {
                srcPath: '/_api/invites-web',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/invites-web',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/invites-web',
                destPath: '',
            },
            {
                srcPath: '/invites',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/invites-web',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/invites-web',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/invites-web',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/invites/invites/site',
                destPath: '/invites/site',
            },
            {
                srcPath: '/invites/invites/account',
                destPath: '/invites/account',
            },
        ],
        'dev._base_domain_': [
            {
                srcPath: '/_api/invites-web',
                destPath: '',
            },
        ],
        'platform.rise.ai': [
            {
                srcPath: '/invites/site',
                destPath: '/invites/site',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
export function getInvites(payload) {
    var _a = serializer(_getAccountInvitesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getAccountInvitesResponse, {
        _accountInvite: _accountInvite,
        _conditionType: _conditionType,
        _inviteAssignment: _inviteAssignment,
        _inviteResourceAssignment: _inviteResourceAssignment,
        _joinedCondition: _joinedCondition,
        _policyCondition: _policyCondition,
    }).fromJSON;
    function __getInvites(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.invites.v1.account_invite',
            method: 'GET',
            methodFqn: 'com.wixpress.invites.api.AccountInvitesApi.GetInvites',
            url: resolveComWixpressInvitesApiAccountInvitesApiUrl({
                protoPath: '/invites/account',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getInvites.fromReq = fromReq;
    __getInvites.__isAmbassador = true;
    return __getInvites;
}
export function getInvite(payload) {
    var _a = serializer(_getAccountInviteRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getAccountInviteResponse, {
        _accountInvite: _accountInvite,
        _conditionType: _conditionType,
        _inviteAssignment: _inviteAssignment,
        _inviteResourceAssignment: _inviteResourceAssignment,
        _joinedCondition: _joinedCondition,
        _policyCondition: _policyCondition,
    }).fromJSON;
    function __getInvite(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.invites.v1.account_invite',
            method: 'GET',
            methodFqn: 'com.wixpress.invites.api.AccountInvitesApi.GetInvite',
            url: resolveComWixpressInvitesApiAccountInvitesApiUrl({
                protoPath: '/invites/account/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getInvite.fromReq = fromReq;
    __getInvite.__isAmbassador = true;
    return __getInvite;
}
/** Deprecated: please use CreateInvite */
export function invite(payload) {
    var _a = serializer(_accountInviteRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_accountInviteResponse, {
        _accountInvite: _accountInvite,
        _conditionType: _conditionType,
        _inviteAssignment: _inviteAssignment,
        _inviteResourceAssignment: _inviteResourceAssignment,
        _joinedCondition: _joinedCondition,
        _policyCondition: _policyCondition,
    }).fromJSON;
    function __invite(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.invites.v1.account_invite',
            method: 'POST',
            methodFqn: 'com.wixpress.invites.api.AccountInvitesApi.Invite',
            url: resolveComWixpressInvitesApiAccountInvitesApiUrl({
                protoPath: '/invites/account',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __invite.fromReq = fromReq;
    __invite.__isAmbassador = true;
    return __invite;
}
/**
 * Create and send an invite to an array of potential users via email to become team members on this account.
 * The invite may be limited to a specific resource.
 * The caller identity must have sufficient permissions to send invites to the account and to any additional site
 * contexts.
 * Maximum amount of new users per invite is 50.
 */
export function createInvite(payload) {
    var _a = serializer(_createInviteRequest, {
        _conditionType: _conditionType,
        _inviteAssignment: _inviteAssignment,
        _inviteResourceAssignment: _inviteResourceAssignment,
        _joinedCondition: _joinedCondition,
        _policyCondition: _policyCondition,
        _subjectInviteAssignments: _subjectInviteAssignments,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createInviteResponse, {
        _accountInvite: _accountInvite,
        _conditionType: _conditionType,
        _inviteAssignment: _inviteAssignment,
        _inviteResourceAssignment: _inviteResourceAssignment,
        _joinedCondition: _joinedCondition,
        _policyCondition: _policyCondition,
    }).fromJSON;
    function __createInvite(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.invites.v1.account_invite',
            method: 'POST',
            methodFqn: 'com.wixpress.invites.api.AccountInvitesApi.CreateInvite',
            url: resolveComWixpressInvitesApiAccountInvitesApiUrl({
                protoPath: '/invites/account/create',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createInvite.fromReq = fromReq;
    __createInvite.__isAmbassador = true;
    return __createInvite;
}
/** Deprecated: please use CreateInvite */
export function bulkInvite(payload) {
    var _a = serializer(_bulkAccountInviteRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkAccountInviteResponse, {
        _accountInvite: _accountInvite,
        _conditionType: _conditionType,
        _inviteAssignment: _inviteAssignment,
        _inviteResourceAssignment: _inviteResourceAssignment,
        _joinedCondition: _joinedCondition,
        _policyCondition: _policyCondition,
    }).fromJSON;
    function __bulkInvite(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.invites.v1.account_invite',
            method: 'POST',
            methodFqn: 'com.wixpress.invites.api.AccountInvitesApi.BulkInvite',
            url: resolveComWixpressInvitesApiAccountInvitesApiUrl({
                protoPath: '/invites/account/bulk',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkInvite.fromReq = fromReq;
    __bulkInvite.__isAmbassador = true;
    return __bulkInvite;
}
export function resendInvite(payload) {
    var _a = serializer(_resendAccountInviteRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_accountInviteResponse, {
        _accountInvite: _accountInvite,
        _conditionType: _conditionType,
        _inviteAssignment: _inviteAssignment,
        _inviteResourceAssignment: _inviteResourceAssignment,
        _joinedCondition: _joinedCondition,
        _policyCondition: _policyCondition,
    }).fromJSON;
    function __resendInvite(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.invites.v1.account_invite',
            method: 'POST',
            methodFqn: 'com.wixpress.invites.api.AccountInvitesApi.ResendInvite',
            url: resolveComWixpressInvitesApiAccountInvitesApiUrl({
                protoPath: '/invites/account/{inviteId}/resend',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __resendInvite.fromReq = fromReq;
    __resendInvite.__isAmbassador = true;
    return __resendInvite;
}
export function acceptInvite(payload) {
    var _a = serializer(_acceptAccountInviteRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_acceptAccountInviteResponse, {}).fromJSON;
    function __acceptInvite(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.invites.v1.account_invite',
            method: 'POST',
            methodFqn: 'com.wixpress.invites.api.AccountInvitesApi.AcceptInvite',
            url: resolveComWixpressInvitesApiAccountInvitesApiUrl({
                protoPath: '/invites/account/accept',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __acceptInvite.fromReq = fromReq;
    __acceptInvite.__isAmbassador = true;
    return __acceptInvite;
}
export function revokeInvite(payload) {
    var _a = serializer(_revokeAccountInviteRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_revokeAccountInviteResponse, {}).fromJSON;
    function __revokeInvite(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.invites.v1.account_invite',
            method: 'POST',
            methodFqn: 'com.wixpress.invites.api.AccountInvitesApi.RevokeInvite',
            url: resolveComWixpressInvitesApiAccountInvitesApiUrl({
                protoPath: '/invites/account/{inviteId}/revoke',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __revokeInvite.fromReq = fromReq;
    __revokeInvite.__isAmbassador = true;
    return __revokeInvite;
}
/** Deprecated: please use UpdateInviteAssignments */
export function updateInvite(payload) {
    var _a = serializer(_updateAccountInviteRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateAccountInviteResponse, {}).fromJSON;
    function __updateInvite(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.invites.v1.account_invite',
            method: 'PATCH',
            methodFqn: 'com.wixpress.invites.api.AccountInvitesApi.UpdateInvite',
            url: resolveComWixpressInvitesApiAccountInvitesApiUrl({
                protoPath: '/invites/account/{inviteId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateInvite.fromReq = fromReq;
    __updateInvite.__isAmbassador = true;
    return __updateInvite;
}
export function updateInviteAssignments(payload) {
    var _a = serializer(_updateAccountInviteAssignmentsRequest, {
        _conditionType: _conditionType,
        _inviteAssignment: _inviteAssignment,
        _inviteResourceAssignment: _inviteResourceAssignment,
        _joinedCondition: _joinedCondition,
        _policyCondition: _policyCondition,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateAccountInviteAssignmentsResponse, {}).fromJSON;
    function __updateInviteAssignments(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.identity.invites.v1.account_invite',
            method: 'PATCH',
            methodFqn: 'com.wixpress.invites.api.AccountInvitesApi.UpdateInviteAssignments',
            url: resolveComWixpressInvitesApiAccountInvitesApiUrl({
                protoPath: '/invites/account/{inviteId}/assignments',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateInviteAssignments.fromReq = fromReq;
    __updateInviteAssignments.__isAmbassador = true;
    return __updateInviteAssignments;
}
//# sourceMappingURL=http.impl.js.map